<template>
    <svg class="icon icon--file-upload__48 icon--duotone" fill="none" height="48" viewBox="0 0 48 48" width="48"
         xmlns="http://www.w3.org/2000/svg">
        <g class="icon-path__primary">
            <path d="M24 34V22" stroke="black" stroke-miterlimit="10" stroke-width="2"/>
            <path d="M19 27L24 22L29 27" stroke="black" stroke-linecap="square" stroke-miterlimit="10"
                  stroke-width="2"/>
        </g>
        <g class="icon-path__secondary">
            <path d="M30 2V14H42" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
                  stroke-width="2"/>
            <path d="M30 2H6V46H42V14L30 2Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"
                  stroke-miterlimit="10" stroke-width="2"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'FileUploadSvg',
};
</script>
